module.exports = __webpack_public_path__ + "static/media/close.9d8276a0.svg";